module.exports = __webpack_public_path__ + "img/group_peoples.3139e7b1.svg";